import React from 'react';
import { Button, Upload } from 'antd';
import "../../../../assets/chat/chat-upload-footer.scss"

const AttachmentsPopupFooter = ({handleSendWithAttachments, beforeUpload, chatUploadAttachmentList, handleModalCancel}) => {

  return (
    <div className="chat-upload-footer__container">
      <div className="left-side">
        <Upload
          multiple
          showUploadList={false}
          beforeUpload={beforeUpload}
          fileList={chatUploadAttachmentList}
        >
          <Button>Добавить файл</Button>
        </Upload>
      </div>
      <div className="right-side">
        <Button
          size="middle"
          onClick={handleModalCancel}
        >
          Отмена
        </Button>
        <Button
          size="middle"
          type="primary"
          onClick={handleSendWithAttachments}
        >
          Отправить
        </Button>
      </div>
    </div>
  );
};

export default AttachmentsPopupFooter;
